<template>
  <div class="wrapper">
    <div class="cl_list">
      <span>
        <span>处方单号:<span style="letter-spacing: 0px">Y1433223</span></span>
        <span>待支付</span>
      </span>
      <span>
        <span>医生</span>
        <span>梧桐伟</span>
      </span>
      <span>
        <span>就诊人姓名</span>
        <span>马冬梅</span>
      </span>
      <span>
        <span>就诊科室</span>
        <span>玛玛哈哈</span>
      </span>
      <span>
        <span>就诊时间</span>
        <span class="time">2022-12-05 09:22:37</span>
      </span>
      <span class="mode">
        <el-radio v-model="radio" label="1">社保</el-radio>
        <el-radio v-model="radio" label="2">自费</el-radio>
        <!-- <span @click="aaa(1)"><input type="radio" name="radio1" value="1" v-model="param" /><label>社保</label></span>
        <span @click="aaa(2)"><input type="radio" name="radio2" value="2" v-model="param" /><label>自费</label></span> -->
      </span>
      <span>
        <span>总金额:<span style="letter-spacing: 0px">2.80</span>元</span>
        <span class="btn">
          <span>查看详情</span>
          <span>去支付</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      param: 1,
      radio: "1"
    }
  },
  created() {
    
  },
  methods: {
    aaa(value){
      this.param = value
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .cl_list{
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    font-size: 14px;
    >span{
      position: relative;
      padding: 10px 20px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      >span:nth-child(1){
        color: #999;
        letter-spacing: 1px;
      }
    }
    .time{
      position: relative;
      top: 2px;
    }
    .mode{
      font-weight: bold;
      font-size: 16px;
      justify-content: space-around;
      >span:nth-child(1){
        color: black;
        letter-spacing: 1px;
      }
      >span{
        position: relative;
        input{
          position: relative;
          top: 3px;
          width: 16px;
          height: 16px;
          margin-right: 1px;
          accent-color:rgb(55, 118, 255);
        }
      }
    }
    .btn{
      >span{
        letter-spacing: 1px;
        font-size: 12px;
        color: rgb(0, 134, 211);
        padding: 4px 10px;
        border: 1px solid rgb(0, 134, 211);
        border-radius: 14px;
      }
      >span:nth-child(1){
        margin-right: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/payment.vue